import Column from '@components/Column';
import Header from '@components/Header';
import { AppScreen } from '@stackflow/plugin-basic-ui';
import { ActivityComponentType } from '@stackflow/react';

import Complete from './components/Complete';

interface Params {
    cardId: string;
}

const PrepaidCardOrderCompleteActivity: ActivityComponentType<Params> = ({ params }:{params: Params}) => {
  const { cardId } = params;
  return (
        <AppScreen>
            <Column>
                <Header noBackIcon title='새 카드 구매' noShadow/>
                <Complete userPrepaidCardId={cardId}/>
            </Column>
        </AppScreen>
  );
};

export default PrepaidCardOrderCompleteActivity;
